import { useContext, useMemo } from 'react';
import Scrollbar from 'src/components/Scrollbar';
import { SidebarContext } from 'src/context/SidebarContext';
import { Box, Drawer, alpha, styled, useTheme } from '@mui/material';
import SidebarMenu from './SidebarMenu';
import SidebarUserSection from './SidebarUserSection';
import Logo from 'src/components/LogoSign';
import appConfig from 'src/config/appConfig';

const SidebarWrapper = styled(Box)(({ theme }) => ({
  width: theme.sidebar.width,
  minWidth: theme.sidebar.width,
  color: theme.colors.alpha.trueWhite[70],
  position: 'fixed',
  zIndex: 7,
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  transition: 'all 0.2s ease-in-out',
  overflow: 'hidden',
  left: 0,
  top: 0,
  background: `linear-gradient(180deg, ${theme.sidebar.background ?? '#FFFFFF'} 0%, ${alpha(theme.colors.alpha.black[100], 0.02)} 100%)`,
  boxShadow: `0 2px 8px ${alpha(theme.colors.alpha.black[100], 0.08)}`,
  borderRight: `1px solid ${alpha(theme.colors.alpha.black[100], 0.08)}`,
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(1, 2),
  borderBottom: `1px solid ${alpha(theme.colors.alpha.black[100], 0.08)}`,
  marginBottom: theme.spacing(1),
}));

const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flex: 1,
});

const MenuContainer = styled(Box)({
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});

function Sidebar() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const theme = useTheme();

  const SidebarContent = () => (
    <ContentContainer>
      <LogoContainer>
        <Logo width={150} />
      </LogoContainer>
      <MenuContainer>
        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          <Scrollbar>
            <SidebarMenu />
          </Scrollbar>
        </Box>
        <SidebarUserSection />
      </MenuContainer>
    </ContentContainer>
  );
  return (
    <>
      <SidebarWrapper sx={{ display: { xs: 'none', [appConfig.breakMobileView]: 'flex' } }}>
        <SidebarContent />
      </SidebarWrapper>

      <Drawer
        sx={{
          '& .MuiDrawer-paper': {
            width: theme.sidebar.width,
            boxShadow: `0 4px 12px ${alpha(theme.colors.alpha.black[100], 0.1)}`,
            border: 'none',
            backgroundColor: theme.sidebar.background ?? '#ffffff',
          },
        }}
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={sidebarToggle}
        onClose={toggleSidebar}
        variant='temporary'
        elevation={0}
      >
        <SidebarWrapper sx={{ position: 'relative' }}>
          <SidebarContent />
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
